import React, {useState} from 'react'
import {css} from '@emotion/react'
import {logDplWithExtensionParams, EVENTS} from '../util/dpl'
import Button from './templates/protection-v2/button'
import {colors} from '../constants'

const SurveyFeedback = ({title, surveyCompleteTitle, optionData, buttonText}) => {
    const [showSurveySubmitMsg, setShowSurveySubmitMsg] = useState(false)
    const [showSurveyError, setShowSurveyError] = useState(false)
    const [surveyData, setSurveyData] = useState({
        surveyReason: ``,
        surveyReasonText: ``,
    })

    const onSurveyInputChange = (e) => {
        const currentSelection = {}
        const {name, value} = e.target
        currentSelection[name] = value
        setSurveyData({
            ...surveyData,
            ...currentSelection,
        })
    }

    const onSurveySubmit = (event) => {
        event.preventDefault()
        let {surveyReason, surveyReasonText} = surveyData
        // dont log reason text if reason does not correspond with 'other' choice
        if (surveyReason !== '6') {
            surveyReasonText = ``
        } else if (surveyReasonText === '') {
            setShowSurveyError(true)
            return
        }
        setShowSurveyError(false)
        logDplWithExtensionParams(EVENTS.StartpageFeedbackSurvey, {
            surveyReason,
            surveyReasonText,
        })
            .then(() => {
                setShowSurveySubmitMsg(true)
            })
            .catch((e) => {
                // eslint-disable-next-line no-console
                console.error(`can't submit form: ${e}`)
            })
    }

    const renderSurveySubmitMsg = () => {
        return (
            <div
                css={css`
                    min-height: calc(100vh - 750px);
                    h3 {
                        margin: 0 0 1rem;
                        font-size: 20px;
                        line-height: 20px;
                        font-weight: 600;
                    }
                    p {
                        margin: 0 0 2rem;
                    }
                `}
            >
                <h3>{surveyCompleteTitle}</h3>
            </div>
        )
    }
    const renderForm = () => {
        return (
            <div
                css={css`
                    h2 {
                        margin: 0 0 1rem;
                        font-weight: 600;
                        font-size: 20px;
                    }
                `}
            >
                <h2>{title}</h2>
                <form
                    onSubmit={onSurveySubmit}
                    css={css`
                        display: flex;
                        flex-direction: column;
                        min-height: 420px;
                    `}
                >
                    {optionData.map((option, i) => {
                        const {title} = option
                        const inputValue = i + 1 // options are valued 1 - optionData.length
                        const isSelected = String(inputValue) === surveyData.surveyReason
                        return (
                            <label
                                htmlFor={inputValue}
                                key={i}
                                css={css`
                                    background: ${isSelected ? colors.brandBlueUltraLight : ''};
                                    border-radius: 4px;
                                    &:hover {
                                        cursor: pointer;
                                    }
                                    input {
                                        margin: 2px 0 0 0;
                                        &:hover {
                                            cursor: pointer;
                                        }
                                    }
                                    padding: 0.75rem 2rem 0.75rem 1rem;
                                    max-width: 660px;
                                    .option-text-main {
                                        font-weight: 400;
                                        margin: 0 0 0 1rem;
                                        display: inline-block;
                                    }
                                    p {
                                        margin: 0 0 0 2.3rem;
                                    }
                                    textarea {
                                        max-width: 95%;
                                    }
                                    p,
                                    textarea {
                                        display: ${isSelected ? 'block' : 'none'};
                                    }
                                `}
                            >
                                <input
                                    type="radio"
                                    id={inputValue}
                                    value={inputValue}
                                    name="surveyReason"
                                    onChange={onSurveyInputChange}
                                />
                                <span className="option-text-main">{title}</span>
                                {i === optionData.length - 1 && (
                                    <textarea
                                        onChange={onSurveyInputChange}
                                        defaultValue={surveyData.surveyReasonText}
                                        name="surveyReasonText"
                                        maxLength="256"
                                        css={css`
                                            appearance: none;
                                            width: 100%;
                                            color: #3b435c;
                                            border-radius: 4px;
                                            border: ${showSurveyError
                                                ? '1px solid red'
                                                : `1px solid ${colors.midnightLight}`};
                                            font-family: inherit;
                                            padding: 7px;
                                            max-width: 100%;
                                            box-shadow: 0 2px 4px ${colors.whisperDark};
                                            height: 3.875rem;
                                            background-color: ${colors.whisperLight};
                                            font-size: 0.875rem;
                                            margin: 1rem 0 1rem 2.3rem;
                                            &:focus {
                                                border: 1px solid ${colors.brandBlueLight2};
                                                outline: none;
                                            }
                                        `}
                                    />
                                )}
                            </label>
                        )
                    })}
                    <div
                        css={css`
                            padding-top: 1.5rem;
                            margin-top: auto;
                            font-size: 14px;
                        `}
                    >
                        <Button text={buttonText} onClick={() => {}} />
                    </div>
                </form>
            </div>
        )
    }

    return <section className="survey">{showSurveySubmitMsg ? renderSurveySubmitMsg() : renderForm()}</section>
}

export default SurveyFeedback
